import * as React from 'react';
import {WP_CONTENT_PREFIX, FIRST_PAGE, OPTION_PAGE} from '../constants';
import styled from 'styled-components';
import {InfoTitle} from "./GroundInfo";
import {CenterHorizontalWrapper} from "../styled-components/CenterWrapper";
import {analyticsEvent} from "../utils/analytics";
import I18n from "../utils/i18n";
import {Sound, SoundText} from "./StatusBar";

const Pointer = styled.img`
    width: 3vw;
    position: absolute;
    left: -4vw;
`;

const Option = styled.a`
    color: #ffffff;
    text-decoration: none;
    position: relative;
    cursor: pointer;
`;

const SoundWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    margin-top: 2vh;
`;

export class Menu extends React.Component {

    constructor(props) {
        super(props);

        this.LAST_SCREEN = 'lastScreen';

        const firstScreenCursorOptions = {
            START_GAME: 'startGame',
            SETTINGS: 'settings',
            GESTURE_LIST: 'gestureList',
            PLAY_LATER: 'playLater',
        };

        const lastScreenCursorOptions = {
            PLAY_AGAIN: 'playAgain',
            SETTINGS: 'settings',
            GESTURE_LIST: 'gestureList'
        };

        this.cursorOptions = props.type === this.LAST_SCREEN ? lastScreenCursorOptions : firstScreenCursorOptions;

        this.state = {
            cursor: props.type === this.LAST_SCREEN ? this.cursorOptions.PLAY_AGAIN : this.cursorOptions.START_GAME
        };
        this.onMouseEnterOption = this.onMouseEnterOption.bind(this);
        this.onPlayAgainClick = this.onPlayAgainClick.bind(this);
        this.onPlayLaterClick = this.onPlayLaterClick.bind(this);
        this.onStartGameClick = this.onStartGameClick.bind(this);
        this.onSeeListOfGestures = this.onSeeListOfGestures.bind(this);
        this.onSettingsClick = this.onSettingsClick.bind(this);
        this.renderFirstScreen = this.renderFirstScreen.bind(this);
        this.renderLastScreen = this.renderLastScreen.bind(this);
    }

    onMouseEnterOption(option) {
        this.setState({
            cursor: option
        });
    }

    onPlayAgainClick() {
        analyticsEvent('Onboarding',
            'Screen 6',
            'Play again Clicked'
        );
    }

    onPlayLaterClick() {
        analyticsEvent('Onboarding',
            'Screen 1',
            'Overlay Play Later'
        );
        let event = new CustomEvent('playLaterOnboarding');
        document.dispatchEvent(event);
    }

    onStartGameClick() {
        const {toggleHideOverlay} = this.props;
        toggleHideOverlay();
        analyticsEvent('Onboarding',
            'Screen 1',
            'Overlay Play Now'
        );
    }

    onSeeListOfGestures() {
        const {type} = this.props;
        analyticsEvent('Onboarding',
            `Screen ${type === this.LAST_SCREEN ? '6' : '1'}`,
            'See gestures list'
        );
    }

    onSettingsClick() {
        const {type} = this.props;

        analyticsEvent('Onboarding',
            `Screen ${type === this.LAST_SCREEN ? '6' : '1'}`,
            'Overlay Settings'
        );
    }

    renderFirstScreen() {
        const {cursor} = this.state;
        const {musicPlaying, toggleMusicPlaying} = this.props;

        return (
            <React.Fragment>
                <InfoTitle marginTop="3vh" onMouseEnter={() => this.onMouseEnterOption(this.cursorOptions.START_GAME)}>
                    <CenterHorizontalWrapper>
                        <Option onClick={this.onStartGameClick}>
                            {I18n.translate('startGame')}
                            {cursor === this.cursorOptions.START_GAME ? <Pointer src={`${WP_CONTENT_PREFIX}/images/pointer.svg`} /> : null}
                        </Option>
                    </CenterHorizontalWrapper>
                </InfoTitle>
                <InfoTitle marginTop="3vh" onMouseEnter={() => this.onMouseEnterOption(this.cursorOptions.SETTINGS)}>
                    <CenterHorizontalWrapper>
                        <Option href={OPTION_PAGE} target="_blank" onClick={this.onSettingsClick}>
                            {I18n.translate('settings')}
                            {cursor === this.cursorOptions.SETTINGS ? <Pointer src={`${WP_CONTENT_PREFIX}/images/pointer.svg`} /> : null}
                        </Option>
                    </CenterHorizontalWrapper>
                </InfoTitle>
                <InfoTitle marginTop="3vh" onMouseEnter={() => this.onMouseEnterOption(this.cursorOptions.GESTURE_LIST)}>
                    <CenterHorizontalWrapper>
                        <Option href={`${WP_CONTENT_PREFIX}/mouse-gestures.pdf`} target="_blank" onClick={this.onSeeListOfGestures}>
                            {I18n.translate('gestureList')}
                            {cursor === this.cursorOptions.GESTURE_LIST ? <Pointer src={`${WP_CONTENT_PREFIX}/images/pointer.svg`} /> : null}
                        </Option>
                    </CenterHorizontalWrapper>
                </InfoTitle>
                <InfoTitle marginTop="3vh" onMouseEnter={() => this.onMouseEnterOption(this.cursorOptions.PLAY_LATER)}>
                    <CenterHorizontalWrapper>
                        <Option onClick={this.onPlayLaterClick}>
                            {I18n.translate('playLater')}
                            {cursor === this.cursorOptions.PLAY_LATER ? <Pointer src={`${WP_CONTENT_PREFIX}/images/pointer.svg`} /> : null}
                        </Option>
                    </CenterHorizontalWrapper>
                </InfoTitle>
                <SoundWrapper>
                    <SoundText>{musicPlaying ? I18n.translate('soundOff') : I18n.translate('soundOn')}</SoundText>
                    <Sound src={`${WP_CONTENT_PREFIX}/images/sound_${musicPlaying ? 'on' : 'off'}.png`} onClick={toggleMusicPlaying}/>
                </SoundWrapper>
            </React.Fragment>
        );
    }

    renderLastScreen() {
        const {cursor} = this.state;
        return (
            <React.Fragment>
                <InfoTitle marginTop="3vh" onMouseEnter={() => this.onMouseEnterOption(this.cursorOptions.PLAY_AGAIN)}>
                    <CenterHorizontalWrapper>
                        <Option href={FIRST_PAGE} onClick={this.onPlayAgainClick}>
                            {I18n.translate('playAgain')}
                            {cursor === this.cursorOptions.PLAY_AGAIN ? <Pointer src={`${WP_CONTENT_PREFIX}/images/pointer.svg`} /> : null}
                        </Option>
                    </CenterHorizontalWrapper>
                </InfoTitle>
                <InfoTitle marginTop="3vh" onMouseEnter={() => this.onMouseEnterOption(this.cursorOptions.SETTINGS)}>
                    <CenterHorizontalWrapper>
                        <Option href={OPTION_PAGE} target="_blank" onClick={this.onSettingsClick}>
                            {I18n.translate('settings')}
                            {cursor === this.cursorOptions.SETTINGS ? <Pointer src={`${WP_CONTENT_PREFIX}/images/pointer.svg`} /> : null}
                        </Option>
                    </CenterHorizontalWrapper>
                </InfoTitle>
                <InfoTitle marginTop="3vh" onMouseEnter={() => this.onMouseEnterOption(this.cursorOptions.GESTURE_LIST)}>
                    <CenterHorizontalWrapper>
                        <Option href={`${WP_CONTENT_PREFIX}/mouse-gestures.pdf`} target="_blank" onClick={this.onSeeListOfGestures}>
                            {I18n.translate('gestureList')}
                            {cursor === this.cursorOptions.GESTURE_LIST ? <Pointer src={`${WP_CONTENT_PREFIX}/images/pointer.svg`} /> : null}
                        </Option>
                    </CenterHorizontalWrapper>
                </InfoTitle>
            </React.Fragment>
        );
    }

    componentDidMount() {
        const {type} = this.props;
        if(type !== this.LAST_SCREEN) {
            analyticsEvent('Onboarding',
                'Screen 1',
                'Overlay Shown'
            );
        }
    }

    render() {
        const {type} = this.props;
        return type === this.LAST_SCREEN ? this.renderLastScreen() : this.renderFirstScreen();
    }
}
